// extracted by mini-css-extract-plugin
module.exports =  {"container":"_13c3691929--container--qg2Bq","icon":"_13c3691929--icon--m9nbI","link":"_13c3691929--link--KMyHx"};